module.exports = __webpack_public_path__ + "static/img/layout3.bb321c3d.png";